module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.innerVisible) ? _c('div', {
    staticClass: "rt-xpc-guide"
  }, [_c('div', {
    ref: "wrapper",
    staticClass: "rt-xpc-guide-wrapper",
    class: _vm.arrowClass
  }, [_c('div', {
    staticClass: "rt-xpc-guide-header"
  }, [_c('div', {
    staticClass: "rt-xpc-guide-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "rt-xpc-guide-close"
  }, [_c('rt-icon', {
    attrs: {
      "type": "iconFont",
      "size": 16,
      "name": "rt-base-close-x-lined"
    },
    on: {
      "click": _vm.hide
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "rt-xpc-guide-content"
  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "rt-xpc-guide-footer"
  }, [_c('div', {
    staticClass: "rt-xpc-guide-page-number"
  }, [_c('span', {
    staticClass: "rt-xpc-guide-page-current"
  }, [_vm._v(_vm._s(_vm.current) + " /")]), _vm._v(" "), _c('span', {
    staticClass: "rt-xpc-guide-page-total"
  }, [_vm._v(_vm._s(_vm.total))])]), _vm._v(" "), (_vm.current < _vm.total) ? _c('div', {
    staticClass: "rt-xpc-guide-page-btn"
  }, [_c('rt-icon', {
    class: {
      'rt-icon-disabled': _vm.current === 1
    },
    attrs: {
      "type": "iconFont",
      "size": 20,
      "name": "rt-base-circle-arrow-left-lined"
    },
    on: {
      "click": _vm.prev
    }
  }), _vm._v(" "), _c('rt-icon', {
    class: {
      'rt-icon-disabled': _vm.current === _vm.total
    },
    attrs: {
      "type": "iconFont",
      "size": 20,
      "name": ("rt-base-circle-arrow-right-" + (_vm.current === _vm.total ? 'lined' : 'filled'))
    },
    on: {
      "click": _vm.next
    }
  })], 1) : _c('rt-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$tx('开始体验', 'xpc.guide.startExpericencing')) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    ref: "wrapperArrow",
    staticClass: "wrapper-arrow"
  }, [_c('div', {
    staticClass: "wrapper-arrow-dot"
  })])]), _vm._v(" "), _c('div', {
    ref: "mask",
    staticClass: "rt-xpc-guide-mask"
  }), _vm._v(" "), _c('div', {
    ref: "maskBorder",
    staticClass: "rt-xpc-guide-mask-border"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-613bdfda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/guide/main.vue
// module id = 2160
// module chunks = 137